import { render, staticRenderFns } from "./InspectionLoader.vue?vue&type=template&id=f8c4985e&"
import script from "./InspectionLoader.vue?vue&type=script&lang=js&"
export * from "./InspectionLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports